module.exports = __webpack_public_path__ + "files/bc1f86b5b3264b9b7a979fa8b008ae7b.png";